<mat-toolbar color="primary">
  <span>Git Timeline</span>
</mat-toolbar>
